import { LcAddress } from "@/domains/core"

import type { ILockApiTransport } from "./interfaces"
import type { LockOnChainTransport } from "./lock-on-chain-transport"
import type { LockApiData } from "./types"

export class LockApiTransport implements ILockApiTransport {
  constructor(private lockOnChainTransport: LockOnChainTransport) {}

  /**
   * Load all user NFTs from on-chain
   * Pure data loading - no state, no caching, no side effects
   */
  async loadUserNfts(userAddress: LcAddress): Promise<Array<LockApiData>> {
    return await this.lockOnChainTransport.loadUserNfts(userAddress)
  }
}
